const fnIdMap = new WeakMap();
let fnCount = 0;

const getFnId = (fn) => {
  if (typeof fn !== 'function') {
    throw new Error(`expect fn type, but get ${fn}`);
  }

  if (!fnIdMap.has(fn)) {
    fnIdMap.set(fn, ++fnCount);
  }

  return fnIdMap.get(fn);
};

export {
  getFnId,
};
